export const CANCELLATION_MARKER_FULL = "[FULL CANCELLATION]";
export const CANCELLATION_MARKER_PARTIAL = "[PARTIAL CANCELLATION]";
export const RESCHEDULING_MARKER = "[RESCHEDULING REQUEST]";
export const REFUND_REQUEST_MARKER = "[REFUND REQUEST]";

function hasCancellationRequestMarkers(text) {
  if (!text || typeof text !== "string") return false;
  return text.includes(CANCELLATION_MARKER_FULL) || text.includes(CANCELLATION_MARKER_PARTIAL);
}

function hasReschedulingRequestMarker(text) {
  if (!text || typeof text !== "string") return false;
  return text.includes(RESCHEDULING_MARKER);
}

function hasRefundRequestMarker(text) {
  if (!text || typeof text !== "string") return false;
  return text.includes(REFUND_REQUEST_MARKER);
}

function matchLabeledField(text, label) {
  const escaped = label.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const m = text.match(new RegExp(`^${escaped}:\\s*(.*)$`, "im"));
  return m ? m[1].trim() : "";
}

function scanHistoryAndTicket(ticket, hasMarkerFn) {
  if (!ticket) return null;
  const history = ticket.history || ticket.TicketHistories || [];
  for (let i = history.length - 1; i >= 0; i--) {
    const e = history[i];
    const chunk = [e.action_taken, e.customer_query, e.solution].filter(Boolean).join("\n");
    if (hasMarkerFn(chunk)) return chunk;
  }
  const fromTicket = [
    ticket.description,
    ticket.zoho_description,
    ticket.customer_query,
    ticket.action_required,
  ].filter(Boolean).join("\n");
  return hasMarkerFn(fromTicket) ? fromTicket : null;
}

export function findCancellationRequestText(ticket) {
  return scanHistoryAndTicket(ticket, hasCancellationRequestMarkers);
}

export function parseCancellationRequestDetails(text) {
  if (!text || typeof text !== "string") return null;
  const isFull = text.includes(CANCELLATION_MARKER_FULL);
  const isPartial = text.includes(CANCELLATION_MARKER_PARTIAL);
  if (!isFull && !isPartial) return null;

  const cancelType = isFull ? "full" : "partial";
  const paxMatch = text.match(/Passengers to cancel:\s*([^\n\r]*)/i);
  const passengersLine = paxMatch ? paxMatch[1].trim() : "";
  const passengerNames = passengersLine
    ? passengersLine.split(",").map((s) => s.trim()).filter(Boolean)
    : [];
  const cdMatch = text.match(/Customer description:\s*([\s\S]*)/i);
  const customerDesc = cdMatch ? cdMatch[1].trim() : "";

  return { cancelType, passengersLine, passengerNames, customerDesc };
}

export function findReschedulingRequestText(ticket) {
  return scanHistoryAndTicket(ticket, hasReschedulingRequestMarker);
}

export function parseReschedulingRequestDetails(text) {
  if (!text || typeof text !== "string") return null;
  if (!text.includes(RESCHEDULING_MARKER)) return null;

  const reason = matchLabeledField(text, "Reason");
  const preferredDate = matchLabeledField(text, "Preferred Travel Date");
  const preferredTime = matchLabeledField(text, "Preferred Time");
  const preferredAirline = matchLabeledField(text, "Preferred Airline");
  const passengersLine = matchLabeledField(text, "Passengers");
  const passengerNames = passengersLine
    ? passengersLine.split(",").map((s) => s.trim()).filter(Boolean)
    : [];
  const cdMatch = text.match(/Customer description:\s*([\s\S]*)/i);
  const customerDesc = cdMatch ? cdMatch[1].trim() : "";

  return { reason, preferredDate, preferredTime, preferredAirline, passengerNames, customerDesc };
}

export function findRefundRequestText(ticket) {
  return scanHistoryAndTicket(ticket, hasRefundRequestMarker);
}

export function parseRefundRequestDetails(text) {
  if (!text || typeof text !== "string") return null;
  if (!text.includes(REFUND_REQUEST_MARKER)) return null;

  return {
    bookingId: matchLabeledField(text, "Booking"),
    pnr: matchLabeledField(text, "PNR"),
    route: matchLabeledField(text, "Route"),
    customerName: matchLabeledField(text, "Customer"),
    customerEmail: matchLabeledField(text, "Email"),
    customerPhone: matchLabeledField(text, "Phone"),
  };
}
